import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  // `Tooltip` est déjà pris par chart.js plus bas : on aliase celui de MUI.
  Tooltip as MuiTooltip,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TimelineIcon from "@material-ui/icons/Timeline";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import InfoIcon from "@material-ui/icons/Info";
import PaymentIcon from "@material-ui/icons/Payment";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import StripeIcon from "@material-ui/icons/Payment";
import SettingsIcon from "@material-ui/icons/Settings";
import SchoolIcon from "@material-ui/icons/School";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import BookIcon from "@material-ui/icons/Book";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useTheme } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

import DraggableList from "../../components/draggableList";
import DialogWarning from "../../components/dialogWarning";
import MainAppBar from "../../components/MainAppBar";
import { Box, Grid, Container, Typography } from "@material-ui/core";
import ParcoursListComponent from "./components/parcoursList/parcoursListComponent";
import CodeListComponent from "./components/parcoursCodes/codeListComponent";
import NoSubscriptionBanner from "./components/noSubscriptionBanner";
import DisableToursPopover from "../../../utils/disableToursPopover";
import FloatingVideoLink from "../../components/floatingVideoLinks";
import { useTranslation } from "react-i18next";
import TutorialBubble from "../../../utils/tutorialBubble";
import VideoTutorialDialog from "./components/VideoTutorialDialog/VideoTutorialDialogComponent";
import FeatureRequestDialog from "./components/FeatureRequestDialog/FeatureRequestDialogComponent";
import CustomCreationDialog from "./components/CustomCreationDialog/CustomCreationDialogComponent";
import TemplateTourDialog from "./components/TemplateTourDialog/TemplateTourDialogComponent";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import ApiGameAnalytics from "../../../API/ApiGameAnalytics";
import moment from "moment";
import SmartsuppChat from "../../../utils/Smartsupp";
import InfoPopover from "../../../utils/informationButton";
import QRCode from "qrcode.react";

const HomeView = (props) => {
  const { t } = useTranslation();
  const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);
  const [isFeatureRequestDialogOpen, setIsFeatureRequestDialogOpen] = useState(false);
  const [showCopyAlert, setShowCopyAlert] = useState(false);
  const [analyticsData, setAnalyticsData] = useState([]);
  const [isDownloadAppDialogOpen, setIsDownloadAppDialogOpen] = useState(false);
  const [isCustomCreationDialogOpen, setIsCustomCreationDialogOpen] = useState(false);

  const storeLink = "http://studio.landingzone.fr/stores";

  useEffect(() => {
    const fetchAnalytics = async () => {
      if (props.state.tourIdSelected) {
        const response = await ApiGameAnalytics.getAnalyticsTwelveMonths(
          props.state.tourIdSelected
        );
        if (response.status === 200) {
          // Créer un tableau des 12 derniers mois
          const lastTwelveMonths = Array.from({ length: 12 }, (_, i) => {
            const date = moment().subtract(i, "months");
            return {
              month: date.format("YYYY-MM"),
              count: 0,
            };
          }).reverse();

          // Remplir les données réelles
          response.data.items.forEach((item) => {
            const itemMonth = moment(item.created_at).format("YYYY-MM");
            const monthIndex = lastTwelveMonths.findIndex(
              (month) => month.month === itemMonth
            );
            if (monthIndex !== -1) {
              lastTwelveMonths[monthIndex].count++;
            }
          });

          setAnalyticsData(lastTwelveMonths);
        }
      }
    };

    fetchAnalytics();
  }, [props.state.tourIdSelected]);

  const handleCopyLinkPyaments = () => {
    const paymentLink = `${process.env.REACT_APP_API_HOST}/payments/paymentLink/${props.state.tourSelected?.paymentLink}`;
    navigator.clipboard
      .writeText(paymentLink)
      .then(() => {
        setShowCopyAlert(true);
        setTimeout(() => {
          setShowCopyAlert(false);
        }, 3000);
      })
      .catch((err) => {
        console.error("Erreur lors de la copie:", err);
      });
  };

  // Les deux liens partageables (classement général et suivi en direct) sont
  // des pages publiques : on copie l'URL absolue telle qu'un participant la
  // recevra.
  const handleCopyShareLink = (path) => {
    navigator.clipboard
      .writeText(window.location.origin + path)
      .then(() => {
        setShowCopyAlert(true);
        setTimeout(() => {
          setShowCopyAlert(false);
        }, 3000);
      })
      .catch((err) => {
        console.error("Erreur lors de la copie:", err);
      });
  };

  const data = {
    labels: analyticsData.map((item) => {
      const monthKey = moment(item.month + "-01")
        .locale("en")
        .format("MMMM")
        .toLowerCase();
      const year = moment(item.month + "-01").format("YYYY");
      return `${t(`months.${monthKey}`)} ${year}`;
    }),
    datasets: [
      {
        label: t("statistics.sessions"),
        data: analyticsData.map((item) => item.count),
        backgroundColor: "rgba(94, 119, 255, 0.8)",
        borderColor: "rgba(94, 119, 255, 1)",
        borderWidth: 0,
        borderRadius: 4,
        barThickness: 8,
        maxBarThickness: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleColor: "#000",
        bodyColor: "#666",
        borderColor: "#ddd",
        borderWidth: 1,
        padding: 10,
        displayColors: false,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            label += context.parsed.y;
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#666",
          font: {
            size: 11,
          },
          maxRotation: 45,
          autoSkip: true,
          maxTicksLimit: 12,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
          drawBorder: false,
        },
        ticks: {
          color: "#666",
          font: {
            size: 11,
          },
          padding: 5,
          stepSize: 1,
        },
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
  };

  return (
    <>
      <MainAppBar
        headerText={t("home.header_text")}
        showHomeButton={true}
        showAdminButton={props.state.isAdmin}
      />
      <Box
        className={props.classes.mainContent}
        style={{
          backgroundColor: "#F6F8FA",
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="lg" style={{ padding: "24px" }}>
          <Box style={{ paddingLeft: "24px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h4"
                  style={{ fontWeight: 700, marginBottom: 8 }}
                >
                  {t("home.header_page_text")}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {t("home.manage_tours")}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  className={props.classes.headerActions}
                  display="flex"
                  gap={3}
                  flexDirection={{ xs: "column", sm: "row" }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setIsVideoDialogOpen(true)}
                    style={{
                      backgroundColor: "#F8F9FA",
                      color: "#2A3142",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "4px 24px",
                      border: "1px solid #E0E0E0",
                      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                      fontWeight: 600,
                      fontSize: "13px",
                      marginRight: 18,
                      letterSpacing: "0.3px",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <SchoolIcon style={{ fontSize: 20, marginRight: "12px" }} />
                    {t("home.tutorial")}
                  </Button>
                  <Button
                    variant="outlined"
                    component={Link}
                    to="/user/account"
                    style={{
                      backgroundColor: "#F8F9FA",
                      color: "#2A3142",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "4px 24px",
                      border: "1px solid #E0E0E0",
                      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                      fontWeight: 600,
                      marginRight: 18,
                      fontSize: "13px",
                      letterSpacing: "0.3px",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <SettingsIcon
                      style={{ fontSize: 20, marginRight: "12px" }}
                    />
                    {t("home.manage_subscription")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setIsFeatureRequestDialogOpen(true)}
                    style={{
                      backgroundColor: "#F8F9FA",
                      color: "#2A3142",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "4px 10px",
                      border: "1px solid #FF9F43",
                      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                      fontWeight: 600,
                      fontSize: "13px",
                      letterSpacing: "0.3px",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      textAlign: "left",
                      width: { xs: "100%", sm: "auto" },
                      color: "#FF9F43",

                    }}
                  >
                    <HelpOutlineIcon style={{ fontSize: 20, marginRight: "12px" }} />
                    {t("home.feature_request")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <NoSubscriptionBanner
            role={props.role}
            hasTrial={props.hasTrial}
            redirectToSelectedPack={props.state.user?.redirectToSelectedPack}
            userCreatedAt={props.state.user?.createdAt}
            classes={props.classes}
            onOpenCustomCreation={() => setIsCustomCreationDialogOpen(true)}
          />
          {/* <FloatingVideoLink role={props.role}></FloatingVideoLink> */}
          <DisableToursPopover
            userOpenedPopover={props.state.isDisableToursOpened}
          />
          <Box mt={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={5}>
                <Box
                  className={props.classes.pannel}
                  style={{ height: "100%" }}
                >
                  <Typography variant="h6" gutterBottom>
                    {t("home.header_text")}
                  </Typography>
                  <Box
                    style={{
                      flex: { md: 1 },
                      overflow: { md: "auto" },
                      minHeight: { md: 0 },
                    }}
                  >
                    <ParcoursListComponent
                      {...props}
                      role={props.role}
                      tourIdSelected={props.state.tourIdSelected}
                      toursReload={props.state.toursReload}
                    />
                    <Box mt={2}>
                      <Divider style={{ backgroundColor: "#E0E0E0" }} />
                    </Box>
                    <Box
                      mt={2}
                      display="flex"
                      justifyContent="center"
                      flexWrap="wrap"
                      style={{ gap: "12px" }}
                    >
                      <Button
                        className={props.classes.ctaPill}
                        variant="outlined"
                        style={{
                          backgroundColor: "white",
                          color: "#000",
                          textTransform: "none",
                          borderRadius: "30px",
                          padding: "12px 20px",
                          border: "1px solid #E0E0E0",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "280px",
                        }}
                        component={Link}
                        to="/parcours"
                      >
                        {t("home.create_new_tour")}
                        <Box
                          component="span"
                          style={{
                            backgroundColor: "#FF9F43",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          +
                        </Box>
                      </Button>
                      <Button
                        className={props.classes.ctaPill}
                        variant="outlined"
                        style={{
                          backgroundColor: "white",
                          color: "#5E77FF",
                          textTransform: "none",
                          borderRadius: "30px",
                          padding: "12px 20px",
                          border: "1px solid #5E77FF",
                          boxShadow: "0px 2px 4px rgba(94, 119, 255, 0.1)",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "280px",
                        }}
                        onClick={props.handleOpenTemplateTourDialog}
                      >
                        {t("home.select_template")}
                        <Box
                          component="span"
                          style={{
                            backgroundColor: "#5E77FF",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "16px",
                          }}
                        >
                          ✦
                        </Box>
                      </Button>
                    </Box>

                    <TemplateTourDialog
                      open={props.state.isTemplateTourDialogOpen}
                      onClose={props.handleCloseTemplateTourDialog}
                      onCopySuccess={props.handleTemplateTourCopied}
                      onSuccessAlert={props.handleTemplateCopyAlert}
                    />

                    <CustomAlert
                      severity="success"
                      message={props.state.templateSuccessMessage}
                      duration={3000}
                      onClose={props.handleResetTemplateAlert}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={7}>
                <Box
                  className={props.classes.pannel}
                  style={{ height: "100%" }}
                >
                  <Box style={{ marginBottom: 10 }} display="flex" justifyContent="center">
                    <Button
                      variant="contained"
                      size="small"
                      className={props.classes.downloadAppButton}
                      startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                      onClick={() => setIsDownloadAppDialogOpen(true)}
                    >
                      {t("home.download_app")}
                    </Button>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography variant="h6">
                        {t("home.tour_codes")}
                      </Typography>
                    </Box>
                    <Button
                      className={props.classes.ctaPill}
                      variant="outlined"
                      style={{
                        backgroundColor: "white",
                        color: "#000",
                        textTransform: "none",
                        borderRadius: "30px",
                        padding: "8px 16px",
                        border: "1px solid #E0E0E0",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                      onClick={props.handleOpenAddCodeDialog}
                    >
                      {t("home.generate_code")}
                      <Box
                        component="span"
                        style={{
                          backgroundColor: "#FF9F43",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "20px",
                          fontWeight: "bold",
                          marginLeft: "8px",
                        }}
                      >
                        +
                      </Box>
                    </Button>
                  </Box>
                  <Divider
                    style={{ backgroundColor: "#E0E0E0", marginBottom: 24 }}
                  />
                  <Box flex={1}>
                    <CodeListComponent
                      {...props}
                      role={props.role}
                      tourId={props.state.tourIdSelected}
                      ref={props.setCodeListRef}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginTop: "16px" }}>
              <Grid item xs={12} md={5}>
                <Box
                  className={props.classes.pannel}
                  style={{ minHeight: "200px" }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Box display="flex" alignItems="center">
                      <Typography variant="h6">
                        {t("home.tour_statistics")}
                      </Typography>
                      {/* Le compteur n'apparaît que s'il y a effectivement une
                          partie ouverte : pas de badge « 0 en cours » qui
                          bruite le tableau de bord en permanence. */}
                      {props.state.liveSessionsCount > 0 && (
                        <Box
                          display="flex"
                          alignItems="center"
                          style={{
                            marginLeft: 12,
                            marginRight: 12,
                            backgroundColor: "#FFF4D6",
                            color: "#8A5A00",
                            borderRadius: 20,
                            padding: "4px 12px",
                            fontSize: "0.8125rem",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span className={props.classes.liveDot} />
                          {t("home.live_sessions", {
                            count: props.state.liveSessionsCount,
                          })}
                        </Box>
                      )}
                    </Box>
                    {props.state.tourIdSelected && (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() =>
                          props.history.push(
                            `/sessions?tourId=${props.state.tourIdSelected}`
                          )
                        }
                        style={{
                          backgroundColor: "#232C48",
                          color: "white",
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 500,
                          padding: "8px 16px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          "&:hover": {
                            backgroundColor: "#1a2338",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                          },
                        }}
                      >
                        {t("home.show_sessions")}
                      </Button>
                    )}
                  </Box>
                  <Box className={props.classes.chartContainer}>
                    <Bar options={options} data={data} />
                  </Box>

                  {(props.state.tourSelected?.likes !== 0 ||
                    props.state.tourSelected?.dislikes !== 0) &&
                    props.state.isAdmin && (
                      <Box className={props.classes.playerReviewsContainer}>
                        <Typography
                          className={props.classes.playerReviewsPercentage}
                        >
                          {(
                            (props.state.tourSelected?.likes /
                              (props.state.tourSelected?.likes +
                                props.state.tourSelected?.dislikes)) *
                            100
                          ).toFixed(0)}
                          %
                        </Typography>
                        <Typography
                          className={props.classes.playerReviewsLabel}
                        >
                          {t("player_reviews_percentage")}
                        </Typography>
                      </Box>
                    )}
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box style={{ position: "relative" }}>
                  {props.state.user?.role === "NO_SUBSCRIBTION" ||
                    props.state.user?.role === "NEW_MEMBER" ? (
                    <Box
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                        backgroundColor: "rgba(31, 41, 55, 0.2)",
                        backdropFilter: "blur(2px)",
                        borderRadius: "20px",
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          color: "white",
                          fontWeight: 600,
                          textAlign: "center",
                          padding: "0 24px",
                        }}
                      >
                        {t("home.get_stripe_connect_account")}
                      </Typography>
                    </Box>
                  ) : null}
                  <Box
                    className={props.classes.pannel}
                    style={{
                      minHeight: "200px",
                      background:
                        "linear-gradient(135deg, #00C853 0%, #009624 100%)",
                      borderRadius: "24px",
                      position: "relative",
                      overflow: "hidden",
                      padding: "32px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                      minHeight: "390px",
                    }}
                  >
                    <Box>
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 24,
                          position: "relative",
                          zIndex: 2,
                        }}
                      >
                        <PaymentIcon
                          style={{
                            fontSize: 28,
                            color: "white",
                            marginRight: 12,
                          }}
                        />
                        <Typography
                          variant="h6"
                          style={{ color: "white", fontWeight: 600 }}
                        >
                          {t("home.payment_module")}
                        </Typography>
                        <Box style={{ marginLeft: 10, display: "flex" }}>
                          <InfoPopover
                            title={t("home.payment_fees_popover_title")}
                            text={t("home.payment_fees_popover_text")}
                            isWhite
                          />
                        </Box>
                      </Box>

                      <Box
                        position="relative"
                        zIndex={1}
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          gap: "16px",
                          minHeight: "215px",
                        }}
                      >
                        {props.state.accountStripeConnectActive &&
                          props.state.tourSelected?.userCanMonetizedTour &&
                          !props.state.tourSelected?.monetizationPaused && (
                            <Box>
                              <Typography
                                variant="h3"
                                style={{
                                  fontWeight: "bold",
                                  color: "white",
                                  marginBottom: "4px",
                                }}
                              >
                                {
                                  props.state.tourSelected
                                    ?.tourMonetizationPrice
                                }
                                €
                              </Typography>
                              <Typography
                                style={{
                                  color: "rgba(255, 255, 255, 0.9)",
                                  fontSize: "0.875rem",
                                }}
                              >
                                {t("home.tour_price")}
                              </Typography>
                            </Box>
                          )}

                        {props.state.accountStripeConnectActive &&
                          props.state.tourSelected?.userCanMonetizedTour && (
                            <Button
                              className={props.classes.glassButton}
                              variant="contained"
                              fullWidth
                              component={Link}
                              to={`/sell-tour-configuration?tourId=${props.state.tourIdSelected}`}
                              style={{
                                backgroundColor: "rgba(255, 255, 255, 0.15)",
                                color: "white",
                                textTransform: "none",
                                borderRadius: "50px",
                                padding: "12px 24px",
                                maxWidth: "240px",
                                border: "1px solid rgba(255, 255, 255, 0.2)",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                                  transform: "translateY(-2px)",
                                },
                              }}
                            >
                              <SettingsIcon style={{ fontSize: 20 }} />
                              {t("home.configure_selling")}
                            </Button>
                          )}
                        {/* {props.state.TODO && ( */}
                        {props.state.accountStripeConnectActive &&
                          props.state.tourSelected?.userCanMonetizedTour &&
                          !props.state.tourSelected?.monetizationPaused &&
                          props.state.tourSelected?.paymentLink ? (
                          <Button
                            className={props.classes.glassButton}
                            variant="contained"
                            fullWidth
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              color: "white",
                              textTransform: "none",
                              borderRadius: "50px",
                              padding: "12px 24px",
                              maxWidth: "240px",
                              border: "1px solid rgba(255, 255, 255, 0.2)",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                transform: "translateY(-2px)",
                              },
                            }}
                            onClick={handleCopyLinkPyaments}
                          >
                            <StripeIcon style={{ fontSize: 20 }} />
                            {t("home.copy_stripe_link")}
                          </Button>
                        ) : !props.state.accountStripeConnectActive ? (
                          <Button
                            className={props.classes.glassButton}
                            variant="contained"
                            fullWidth
                            component={Link}
                            to={`/user/account`}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              color: "white",
                              textTransform: "none",
                              borderRadius: "50px",
                              padding: "12px 24px",
                              maxWidth: "240px",
                              border: "1px solid rgba(255, 255, 255, 0.2)",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                transform: "translateY(-2px)",
                              },
                            }}
                          >
                            <SettingsIcon style={{ fontSize: 20 }} />
                            {t("home.configure_monetization")}
                          </Button>
                        ) : !props.state.tourSelected?.userCanMonetizedTour &&
                          props.state.accountStripeConnectActive &&
                          !props.state.tourSelected?.userAskedMonetization ? (
                          <Button
                            className={props.classes.glassButton}
                            variant="contained"
                            fullWidth
                            component={Link}
                            to={`/request-stripe-for-tours`}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              color: "white",
                              textTransform: "none",
                              borderRadius: "50px",
                              padding: "12px 24px",
                              maxWidth: "240px",
                              border: "1px solid rgba(255, 255, 255, 0.2)",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                transform: "translateY(-2px)",
                              },
                            }}
                          >
                            <SettingsIcon style={{ fontSize: 20, marginRight: 12 }} />
                            {t("home.ask_monetization")}
                          </Button>
                        ) : !props.state.tourSelected?.userCanMonetizedTour &&
                          props.state.accountStripeConnectActive &&
                          props.state.tourSelected?.userAskedMonetization ? (
                          <Box
                            display="flex"
                            alignItems="center"
                            gap={2}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              padding: "12px 16px",
                              borderRadius: "20px",
                              marginTop: "8px",
                            }}
                          >
                            <Typography
                              style={{
                                color: "rgba(255, 255, 255, 0.7)",
                                fontSize: "0.875rem",
                                fontWeight: 500,
                              }}
                            >
                              {t("request_stripe_for_tours.processing")}
                            </Typography>
                          </Box>
                        ) : (
                          <></>
                        )}
                        {/* )} */}
                      </Box>
                    </Box>

                    <Box
                      position="absolute"
                      right={-20}
                      top={40}
                      style={{
                        fontSize: "180px",
                        color: "rgba(255, 255, 255, 0.1)",
                        fontWeight: "bold",
                        zIndex: 0,
                      }}
                    >
                      €
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box
                  style={{
                    backgroundColor: "#1F2937",
                    borderRadius: "24px",
                    padding: "32px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "none",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    gap: 24,
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {!props.state.leaderboardActivated ? (
                    <Box
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                        backgroundColor: "rgba(31, 41, 55, 0.2)",
                        backdropFilter: "blur(2px)",
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          color: "white",
                          fontWeight: 600,
                          textAlign: "center",
                          padding: "0 24px",
                        }}
                      >
                        {t("home.change_subscription_unlock")}
                      </Typography>
                    </Box>
                  ) : null}
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 24,
                    }}
                  >
                    <EmojiEventsIcon
                      style={{
                        fontSize: 28,
                        color: "#FFD700",
                        marginRight: 12,
                      }}
                    />
                    <Typography
                      variant="h6"
                      style={{ color: "white", fontWeight: 600 }}
                    >
                      {t("leaderboard.title")}
                    </Typography>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      gap: "16px",
                    }}
                  >
                    <Typography
                      style={{
                        color: "rgba(255, 255, 255, 0.9)",
                        textAlign: "center",
                        marginBottom: "8px",
                        fontSize: "0.875rem",
                      }}
                    >
                      {t("home.share_leaderboard")}
                    </Typography>

                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Link
                        style={{
                          textDecoration: "none",
                        }}
                        to={`/statistiques?tourId=${props.state.tourIdSelected}`}
                        target="_blank"
                      >
                        <Button
                          className={props.classes.glassButton}
                          variant="contained"
                          fullWidth
                          style={{
                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "50px",
                            padding: "12px 24px",
                            maxWidth: "240px",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          <VisibilityIcon
                            style={{ fontSize: 20, marginRight: 12 }}
                          />
                          {t("home.show_public_leaderboard")}
                        </Button>
                      </Link>

                      <MuiTooltip title={t("home.copy_link")}>
                        <IconButton
                          className={props.classes.glassButton}
                          aria-label={t("home.copy_link")}
                          onClick={() =>
                            handleCopyShareLink(
                              `/statistiques?tourId=${props.state.tourIdSelected}`
                            )
                          }
                          style={{
                            color: "white",
                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            padding: "10px",
                          }}
                        >
                          <FileCopyIcon style={{ fontSize: 18 }} />
                        </IconButton>
                      </MuiTooltip>
                    </Box>

                    {/* Suivi en direct : classement d'un groupe qui joue en ce
                        moment, à distinguer du classement général ci-dessus qui
                        agrège jour / mois / total. */}
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Link
                        style={{
                          textDecoration: "none",
                        }}
                        to={`/suivi-direct?tourId=${props.state.tourIdSelected}`}
                        target="_blank"
                      >
                        <Button
                          className={props.classes.glassButton}
                          variant="contained"
                          fullWidth
                          style={{
                            backgroundColor: "rgba(232, 198, 53, 0.9)",
                            color: "#151B2F",
                            textTransform: "none",
                            borderRadius: "50px",
                            padding: "12px 24px",
                            maxWidth: "240px",
                            fontWeight: 600,
                            border: "1px solid rgba(232, 198, 53, 0.4)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          <TimelineIcon
                            style={{ fontSize: 20, marginRight: 12 }}
                          />
                          {t("home.show_live_scores")}
                        </Button>
                      </Link>

                      <MuiTooltip title={t("home.copy_link")}>
                        <IconButton
                          className={props.classes.glassButton}
                          aria-label={t("home.copy_link")}
                          onClick={() =>
                            handleCopyShareLink(
                              `/suivi-direct?tourId=${props.state.tourIdSelected}`
                            )
                          }
                          style={{
                            color: "#151B2F",
                            backgroundColor: "rgba(232, 198, 53, 0.9)",
                            border: "1px solid rgba(232, 198, 53, 0.4)",
                            padding: "10px",
                          }}
                        >
                          <FileCopyIcon style={{ fontSize: 18 }} />
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              {props.state.isAdmin && (
                <Grid item xs={12}>
                  <Box
                    style={{
                      backgroundColor: "#1F2937",
                      borderRadius: "24px",
                      padding: "32px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                      border: "none",
                      color: "white",
                      display: "flex",
                      flexDirection: "column",
                      gap: 24,
                      height: "100%",
                      position: "relative",
                      overflow: "hidden",

                      display: "flex",
                      alignItems: "center",
                      // gap: "8px",
                      // justifyContent: "center",
                    }}
                  >
                    <Typography variant="h6" style={{ color: "white" }}>
                      Générer un parcours avec l'IA
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ color: "white", fontSize: "12px" }}
                    >
                      Inclure un maximum d'informations comme :
                      <br />- Type de parcours (escape game, jeux de piste,
                      culture, etc...)
                      <br />- Lieu
                      <br />- Niveau de difficultés
                      <br />- Sujet du parcours
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={props.state.aiTourIsQRCode}
                          onChange={(event) =>
                            props.handleSwitchAiTourIsQrCode(event)
                          }
                        />
                      }
                      label="Parcours QR Code"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={props.state.generateImages}
                          onChange={(event) =>
                            props.handleGenerateImages(event)
                          }
                        />
                      }
                      label="Générer les images"
                    />
                    <TextField
                      name="zonesNb"
                      id="filled-required"
                      label="Nombre de zones"
                      variant="outlined"
                      onChange={props.handleZonesNbChange}
                      inputProps={{ max: 10, min: 1 }}
                      size="small"
                      type="number"
                      value={props.state.zonesNb}
                      style={{
                        backgroundColor: "white",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        minWidth: "200px",
                      }}
                    />
                    <TextField
                      name="enigmasNb"
                      id="filled-required"
                      label="Nombre d'énigmes par zones"
                      variant="outlined"
                      onChange={props.handleEnigmasPerZoneChange}
                      inputProps={{ max: 8, min: 1 }}
                      size="small"
                      type="number"
                      value={props.state.enigmasPerZone}
                      style={{
                        backgroundColor: "white",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        minWidth: "200px",
                      }}
                    />
                    <TextField
                      name="createAiTour"
                      id="filled-required"
                      label="Description du parcours"
                      variant="outlined"
                      onChange={props.handleTextPromptChange}
                      inputProps={{ maxLength: 10000 }}
                      multiline
                      rows={5}
                      style={{
                        backgroundColor: "white",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        width: "100%",
                      }}
                    />
                    <Button
                      onClick={props.handleGenerateTourWithAI}
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.15)",
                        color: "white",
                        textTransform: "none",
                        borderRadius: "50px",
                      }}
                    >
                      {props.state.aiTourCreationIsLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Créer"
                      )}
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
          {showCopyAlert && (
            <CustomAlert
              severity="success"
              message="Lien copié dans le presse-papier"
              duration={3000}
              onClose={() => setShowCopyAlert(false)}
              height={20}
            />
          )}
          {/* TUTO DÉSACTIVÉ - à réactiver si besoin
          {props.state.user?.tutorialSteps?.step1 == false && (
            <TutorialBubble
              style={{ position: "absolute" }}
              message={t("tuto.step1")}
            />
          )}
          {props.state.user?.tutorialSteps?.step5 == false &&
            props.state.user?.tutorialSteps?.step1 == true &&
            props.state.user?.tutorialSteps?.step2 == true &&
            props.state.user?.tutorialSteps?.step3 == true &&
            props.state.user?.tutorialSteps?.step4 == true && (
              <TutorialBubble
                style={{ position: "absolute" }}
                message={`${t("tuto.step5Part1")}${props.state.testCode ? props.state.testCode : ""
                  }${t("tuto.step5Part2")}`}
              />
            )}
          */}
          <SmartsuppChat user={props.state.user} isFr={props.isFr} />
          <VideoTutorialDialog
            open={isVideoDialogOpen}
            onClose={() => setIsVideoDialogOpen(false)}
          />
          <FeatureRequestDialog
            open={isFeatureRequestDialogOpen}
            onClose={() => setIsFeatureRequestDialogOpen(false)}
          />
          <CustomCreationDialog
            open={isCustomCreationDialogOpen}
            onClose={() => setIsCustomCreationDialogOpen(false)}
            userEmail={props.state.user?.email}
            userFirstName={props.state.user?.firstname}
            userLastName={props.state.user?.lastname}
          />
          <Dialog
            open={isDownloadAppDialogOpen}
            onClose={() => setIsDownloadAppDialogOpen(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle
              disableTypography
              className={props.classes.downloadAppDialogTitle}
            >
              <Typography
                variant="h6"
                style={{ fontWeight: 800, color: "#111827" }}
              >
                {t("home.download_app_dialog_title")}
              </Typography>
              <IconButton
                onClick={() => setIsDownloadAppDialogOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className={props.classes.downloadAppDialogContent}>
              <Typography style={{ color: "#374151", lineHeight: "22px" }}>
                {t("home.download_app_dialog_description")}
              </Typography>

              <Box className={props.classes.downloadAppQrContainer}>
                <QRCode value={storeLink} size={180} includeMargin />
              </Box>

              <Typography style={{ color: "#6B7280", marginBottom: 8 }}>
                {t("home.download_app_store_link_label")}
              </Typography>
              <a
                href={storeLink}
                target="_blank"
                rel="noreferrer"
                className={props.classes.downloadAppLink}
              >
                {storeLink}
              </a>
            </DialogContent>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};

export default HomeView;
